import { render } from "./purchasereport.vue?vue&type=template&id=17de18ec&scoped=true"
import script from "./purchasereport.vue?vue&type=script&lang=js"
export * from "./purchasereport.vue?vue&type=script&lang=js"

import "./report-theme.css?vue&type=style&index=0&id=17de18ec&scoped=true&lang=css"
import "./purchasereport.vue?vue&type=style&index=1&id=17de18ec&scoped=true&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17de18ec"]])

export default __exports__